import Helmet from "react-helmet";
import { listView, photoView, getTitleBase } from "../shared/util";
import React, { Component } from "react";
import request from "superagent";
import ResultsHeader from "./../my-listings/results-header";
import ResultsView from "../homepage/featured/results-view";
import Pagination from "../search/pagination";
import Spinner from "../../../public/img/spinner.svg";
import {
  getAgentIds,
  getEntityLabel,
  getSortField,
  modifyFilter,
  parseBannerFilter,
  parsePage,
  singularListingType,
  getCorrectOffSalesRegion,
} from "../shared/util";

import "./../my-listings/my-listings.scss";

class GlobalListings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        agentId: getAgentIds(props.entity),
        bannerFilter: parseBannerFilter(props),
        resultsPerPage: 12,
        activePage: parsePage(props),
        sortField: getSortField(props, true),
        listingType: singularListingType(props.params.listingType),
        source: "sir",
      },
      rentalsCount: 0,
      salesCount: 0,
      results: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({ isGlobal: true });
    this.globalListings();
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.abort();
    }
    if (this.countRequest) {
      this.countRequest.abort();
    }
  }

  changeFilter = (name, value) => {
    const filter = modifyFilter(this.state.filter, name, value);
    this.setState({ filter: filter }, () => {
      this.globalListings();
    });
  };

  globalListings = () => {
    this.setState({ loading: true });

    this.request = request
      .post(
        "/api/globalListings/findGlobalListings?listingType=" +
          this.state.filter.listingType +
          "&sortBy=" +
          this.state.filter.sortField +
          "&page=" +
          this.state.filter.activePage
      )
      .set("Content-Type", "application/json")
      .send(this.props.entity.siteOptions.globalSettings)
      .end((error, response) => {
        if (response && response.body) {
          this.setState({
            rentalsCount: response.body.rentalsCount,
            salesCount: response.body.salesCount,
            results: response.body.results,
            loading: false,
          });

          if (
            this.state.salesCount === 0 &&
            this.state.rentalsCount > 0 &&
            this.state.filter.listingType !== "rental"
          ) {
            this.props.router.replace("/global-listings/rentals");
            this.changeFilter("listingType", "rental");
          }
        } else {
          console.error(error);
        }
      });
  };

  loading = (title) => {
    return (
      <div className="my-listings featured-listings">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`View exclusive luxury real estate and homes for ${
              this.props.params.listingType === "sales" ? "sale" : "rent"
            } from ${this.props.entity.brand} ${getEntityLabel(
              this.props.entity
            ).toLowerCase()} ${
              this.props.entity.displayName
            } in ${getCorrectOffSalesRegion(
              this.props.entity
            )}. Get details, photos, videos & more.`}
          />
        </Helmet>
        <div className="web-container">
          <div className="page-header">
            <h3>GLOBAL LISTINGS</h3>
            <div className="header-separator"></div>
            <div>
              <div style={{ textAlign: "center" }}>
                <img alt="" src={Spinner}></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const showOptions =
      this.state.results.length > this.props.defaultOptions.listViewLimit
        ? photoView
        : listView;
    const title = `Exclusive Listings - ${getTitleBase(this.props.entity)}`;

    if (this.state.loading) return this.loading(title);

    return (
      <div className="my-listings featured-listings">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`View exclusive luxury real estate and homes for ${
              this.props.params.listingType === "sales" ? "sale" : "rent"
            } from ${this.props.entity.brand} ${getEntityLabel(
              this.props.entity
            ).toLowerCase()} ${
              this.props.entity.displayName
            } in ${getCorrectOffSalesRegion(this.props.entity)}
            }. Get details, photos, videos & more.`}
          />
        </Helmet>
        <div className="web-container">
          <div className="page-header">
            <h3>GLOBAL LISTINGS</h3>
            <div className="header-separator"></div>
          </div>
          <ResultsHeader
            changeFilter={this.changeFilter}
            location={this.props.location}
            resultState={this.state}
            isGlobal={this.state.isGlobal}
          />
          <ResultsView
            listings={this.state.results}
            options={showOptions}
            buildGlobalDetailPage={
              this.props.entity.siteOptions.CreateGlobalDetailPage
            }
            isGlobal={this.state.isGlobal}
          />
          <div className="results-footer container">
            <Pagination
              count={
                this.state.filter.listingType === "rental"
                  ? this.state.rentalsCount
                  : this.state.salesCount
              }
              pageSize={this.state.filter.resultsPerPage}
              activePage={this.state.filter.activePage}
              location={this.props.location}
              changeFilter={this.changeFilter}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default GlobalListings;



// WEBPACK FOOTER //
// ./src/components/global-listings/index.js